'use strict';

// go env doesn't have and need XMLHttpRequest
if (typeof XMLHttpRequest === 'undefined') {
    exports.XMLHttpRequest = {};
} else {
    exports.XMLHttpRequest = XMLHttpRequest; // jshint ignore:line
}




//////////////////
// WEBPACK FOOTER
// ../~/web3/lib/utils/browser-xhr.js
// module id = 471
// module chunks = 0